export class SetMaxBid {
  static type = '[Max Bid] Set max bid value';
  constructor(readonly payload) {}
}

export class SetAllMaxBids {
  static type = '[Max Bid] Set all max bid values';
  constructor(readonly payload) {}
}
